"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { PencilRuler, Shovel, Sprout, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function OurLandscapeExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const services = [{
    title: "Composite & Trex Decks",
    description: "Premium, low-maintenance decking solutions engineered for Northern California durability. As expert deck builders, we install top-tier Trex systems that withstand coastal elements.",
    icon: PencilRuler,
    link: "/CompositeTrexDeckBuildersPage"
  }, {
    title: "Structural & Concrete",
    description: "Robust engineering for challenging Bay Area terrains. Our deck contractor team specializes in structural foundations and concrete integrations for maximum architectural stability.",
    icon: Shovel,
    link: "/StructuralDeckContractorsPage"
  }, {
    title: "Pool Deck Specialists",
    description: "Transform your aquatic space with custom-built pool surrounds. We design and install water-resistant, slip-safe decks that elevate your luxury outdoor living experience.",
    icon: Sprout,
    link: "/PoolDeckContractorsPage"
  }];
  return <section data-section-id="36539" id="our-specialized-decking-solutions" className="bg-background py-24 overflow-hidden">
      <div ref={ref} className={cn("container mx-auto px-6 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-16">
          {services.map((service, i) => <Link key={i} to={service.link} className="group block h-full" data-index={i}>
              <Card className="h-full bg-card border-none shadow-sm hover:shadow-2xl transition-all duration-500 ease-out transform group-hover:-translate-y-[10px] rounded-sm overflow-hidden gap-0 py-0">
                <CardHeader className="pt-12 px-10 pb-6">
                  <div className="mb-8">
                    <service.icon strokeWidth={1.5} className="w-14 h-14 text-primary" />
                  </div>
                  <CardTitle className="font-default text-[32px] leading-tight text-secondary font-bold tracking-tight">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="px-10 pb-4">
                  <CardDescription className="font-default text-base text-muted-foreground leading-relaxed line-clamp-3">
                    {service.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="px-10 pb-12 pt-4 mt-auto">
                  <div className="flex items-center gap-3 text-secondary font-bold text-xs tracking-widest uppercase opacity-0 transform translate-y-4 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
                    View Solutions <ArrowRight className="w-4 h-4" />
                  </div>
                </CardFooter>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}